var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.5H1C0.801088 1.5 0.610322 1.57902 0.46967 1.71967C0.329018 1.86032 0.25 2.05109 0.25 2.25V15C0.25 15.3978 0.408035 15.7794 0.68934 16.0607C0.970644 16.342 1.35218 16.5 1.75 16.5H18.25C18.6478 16.5 19.0294 16.342 19.3107 16.0607C19.592 15.7794 19.75 15.3978 19.75 15V2.25C19.75 2.05109 19.671 1.86032 19.5303 1.71967C19.3897 1.57902 19.1989 1.5 19 1.5ZM10 9.48281L2.92844 3H17.0716L10 9.48281ZM7.25406 9L1.75 14.0447V3.95531L7.25406 9ZM8.36406 10.0172L9.48906 11.0531C9.62743 11.1801 9.80842 11.2506 9.99625 11.2506C10.1841 11.2506 10.3651 11.1801 10.5034 11.0531L11.6284 10.0172L17.0659 15H2.92844L8.36406 10.0172ZM12.7459 9L18.25 3.95438V14.0456L12.7459 9Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c2856c76a007f4cc041860969fb8db01.svg";
export { ForwardRef as ReactComponent };